import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import Form from 'components/form/Form';
import FormItem from 'components/form/FormItem';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import useAppTracking from 'hooks/useAppTracking';

import OTPVerification from 'pages/OTP/OTPVerification';

import { setUserDetails } from 'stores/userSlice';

const defaultColSpan = {
	md: 12
};

const MobileVerifyModal = NiceModal.create(() => {
	const modal = useModal();

	const handleCloseModal = () => {
		modal.resolve(true);
		modal.remove();
	};

	const schema = useMemo(
		() =>
			yup
				.object()
				.shape({
					phone: yup.string().nullable().required().phoneNumber()
				})
				.required(),
		[]
	);

	const user = useSelector((state) => state?.user);
	const { phone, mobileVerified, userType } = user;
	const dispatch = useDispatch();
	const { update } = useAppTracking();

	const formMethods = useForm({
		defaultValues: {
			phone
		},
		resolver: yupResolver(schema)
	});

	return (
		<Modal maxWidth="small" fullwidth className="mobile-verify-modal" closeButton={true}>
			<ModalTitle>
				<Typography variant="p1">verifyMobileNumber</Typography>
			</ModalTitle>
			<ModalContent>
				<Form formMethods={formMethods} borderless>
					<FormItem colSpan={defaultColSpan} label="mobileNumber">
						<OTPVerification
							name="phone"
							otpType="currentPhone"
							isVerified={mobileVerified}
							onVerification={(value) => {
								handleCloseModal();
								dispatch(
									setUserDetails({
										phone: value,
										mobileVerified: true,
										...(userType === 'companyAdmin' && { companyAdminVerified: true })
									})
								);
								update({ phone: value });
							}}
							type="phone"
						/>
					</FormItem>
				</Form>
			</ModalContent>
		</Modal>
	);
});

export default MobileVerifyModal;
